export const isTrusted = (origin: string, configuration: string[]) => {
  let trusted = true;

  if (configuration && configuration.length > 0) {
    try {
      const host = new URL(`https://${origin}`);
      trusted = configuration.some(domain =>
        host.hostname.match(`^${domain.replace(/\./g, '\\.').replace(/\*/g, '.*')}$`)
      );
    } catch (e) {
      trusted = false;
    }
  }

  return trusted;
};
